import React from 'react';
import { Card } from '~/components/Card';
import { ServicesContext } from '~/services';
import {
    InAppCountSettings,
    NotificationFilters,
    EmailNotificationSettings,
} from '~/components/Profile';

export function NotificationSettings() {
    const servicesContext = React.useContext(ServicesContext);

    if (!servicesContext.user.hasFeatureToggle('notification_settings')) return null;

    return (
        <Card
            className="mt-3"
            title={
                <div className="row mb-0">
                    <div className="col-8 align-self-center">Notification Settings</div>
                </div>
            }
        >
            <NotificationFilters />
            <InAppCountSettings />
            <EmailNotificationSettings />
        </Card>
    );
}
